import { useContextEnsuringProvider } from '@iheartjane/utils';
import { createContext } from 'react';
import type { PropsWithChildren } from 'react';

interface RegistrationValues {
  email: string;
  nickname?: string;
  password: string;
  phone: string;
}

interface JaneAuthenticationErrors {
  login?: string;
  register?: string[];
  resetPassword?: string;
}

interface OAuthProviderOptions {
  onClick: (source: string) => void;
  showLogin: boolean;
}

export interface Authentication {
  apple: OAuthProviderOptions;
  errors: JaneAuthenticationErrors | null;
  google: OAuthProviderOptions;
  login: (
    credentials: { email: string; password: string },
    source: string
  ) => void;
  logOut: () => void;
  register: (newUser: RegistrationValues) => void;
  resetError: () => void;
  resetPassword: (user: { email: string }) => Promise<boolean>;
}

const AuthenticationContext = createContext<Authentication | null>(null);
AuthenticationContext.displayName = 'Authentication';

export const useAuthentication = () =>
  useContextEnsuringProvider(AuthenticationContext);

export const AuthenticationProvider = ({
  children,
  value,
}: PropsWithChildren<{ value: Authentication }>) => {
  return (
    <AuthenticationContext.Provider value={value}>
      {children}
    </AuthenticationContext.Provider>
  );
};
